import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import FormReact from 'react-bootstrap/Form';
import { Button as ButtonReact } from 'react-bootstrap';
import { triggerBase64Download } from 'common-base64-downloader-react';
import publicIp from 'public-ip';

import { BsWhatsapp } from "react-icons/bs";


import { useAcceptanceTerm } from "../../hooks/useAcceptanceTerm";

import { IFormInput, InductionQuestionConfiguration } from "../../TypesOrInterfaces/induction";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { Fallback } from "../FallBack";
import { Button } from "../Button";
import attachments from "../../acceptanceTerm.json";
import PDFViewer from "../PDFViewer";

import termoAceito from '../../assets/termoAceito.png';
import decline from '../../assets/decline.png';
import notFound from '../../assets/notFound.png';
import phone from '../../assets/phone.png';

import { Container, Form, ButtonContainer } from './styles';


export default function Acceptance() {

    const [ip, setIp] = useState('');
    const [pdf, setPDF] = useState<any>();
    const [pdfName, setPdfName] = useState('');
    const [width, setWidth] = useState(window.innerWidth);

    const {
        benefitId,
        benefitName,
        configuration,
        quizId,
        isActiveLoader,
        acceptedTheTerm,
        termAnswered,
        beneficiaryPreCadNotFound,
        acceptTerm,
        declineTerm
    } = useAcceptanceTerm();

    const { register, handleSubmit, errors } = useForm();

    const whatsApp = (attachments as any)[benefitId]?.whatsApp;
    const callCenter = (attachments as any)[benefitId]?.callCenter;
    const url = (attachments as any)[benefitId]?.url;
    
    function questionOrdering(a: InductionQuestionConfiguration, b: InductionQuestionConfiguration) {
        if (a.order > b.order)
            return 1;
        else if (a.order < b.order) return -1;
        return 0;
    }

    const quiz = configuration?.quiz?.filter(f => f.id === quizId)[0];

    useEffect(() => {

        async function getIp() {
            const response = await publicIp.v4();
            setIp(response);
        }

        getIp();

        const arquive = (attachments as any)[benefitId];

        if (arquive) {
            setPDF(arquive.content);
            setPdfName(arquive.name);
        }

    }, []);

    useEffect(() => {
        setWidth(window.innerWidth);
    }, [window.innerWidth]);

    async function handleQuizzesSubmit(data: IFormInput) {
        acceptTerm(data);
    }

    async function handleDecline() {
        declineTerm();
    }

    return (
        <>
            <Header />
            <Container>
                {termAnswered && (
                    acceptedTheTerm ? (
                        <div className="react-div_accepted">
                            <img src={termoAceito} alt="imagem-termo-aceito" />
                            <p>O aceite do <strong>termo de consentimento</strong> foi realizado com sucesso.</p>
                            <span>Agradecemos sua participação!</span>
                        </div>
                    ) : (
                        beneficiaryPreCadNotFound ? (
                            <div className="react-div_accepted">
                                <img src={notFound} alt="imagem-termo-aceito" />
                                <p>Lamentamos, mas não encontramos o seu cadastro na nossa base.</p>
                                <p className="tagline">Caso tenha interesse em participar do programa {benefitName}, dirija-se a uma farmácia credenciada ou cadastre-se por meio de um dos canais abaixo:</p>
                                <div className="info-plan-container">
                                    {whatsApp && (
                                        <span> <BsWhatsapp /> {whatsApp}</span>
                                    )}
                                    {callCenter && (
                                        <span><img src={phone} width={20} height={20} alt="phone-img" /> {callCenter}</span>
                                    )}
                                    {url && (
                                        <span>{url}</span>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <div className="react-div_accepted">
                                <img src={decline} alt="imagem-termo-aceito" />
                                <p>Lamentamos que você tenha decidido não <strong>aceitar os termos</strong> neste momento.</p>
                                <p className="tagline">Gostaríamos de informar que, de acordo com nossa política de privacidade, seus dados cadastrais serão excluídos de nossa base. Se tiver alguma dúvida ou precisar de mais informações sobre esse processo, entre em contato conosco. Estamos à disposição para ajudar.</p>
                                <span>Agradecemos sua participação!</span>
                            </div>
                        )
                    )
                )}
   
                {!termAnswered && 
                    (
                        <>
                            <div>
                                <h1>Termo de aceite e consentimento - <strong>{benefitName}</strong></h1>
                            </div>
                            <div style={{ padding: '10px' }}>
                                {width < 640 ? (
                                    <ButtonReact
                                        variant="outline-info"
                                        onClick={() => triggerBase64Download(`data:application/pdf;base64,${pdf}`, pdfName)}
                                    >
                                        Faça o download do termo de consentimento
                                    </ButtonReact>

                                ) :
                                    <PDFViewer url={pdf} />

                                }

                            </div>
                            <Form onSubmit={handleSubmit(handleQuizzesSubmit)}>

                                <div>
                                    {
                                        quiz?.questions.sort(questionOrdering).map(question => {

                                            switch (question.questionAlias.toLowerCase()) {
                                                case "question_accepted_term":
                                                case "question_late-term_acceptance":
                                                    return (
                                                        <>
                                                            <FormReact.Check
                                                                type="checkbox"
                                                                label={question.title}
                                                                name={String(question.id)}
                                                                key={question.id}
                                                                ref={register({
                                                                    required: {
                                                                        value: question.isRequired,
                                                                        message: 'Termos de aceite obrigatórios'
                                                                    }
                                                                })}
                                                            />
                                                            {errors[String(question.id)] && <span className="input-error-message">{errors[String(question.id)].message}</span>}
                                                        </>
                                                    )

                                                case "question_lgpd_data_accepted_term":
                                                    return (
                                                        <input
                                                            name={String(question.id)}
                                                            key={question.id}
                                                            defaultValue={new Intl.DateTimeFormat('pt-BR', {
                                                                day: '2-digit'
                                                                , month: '2-digit'
                                                                , year: 'numeric'
                                                                , hour: 'numeric'
                                                                , minute: 'numeric'
                                                                , second: 'numeric'
                                                                , hour12: false
                                                            }).format(new Date())}
                                                            ref={register}
                                                            hidden
                                                        />

                                                    );
                                                case "question_lgpd_ip":
                                                    return (
                                                        <input
                                                            key={question.id}
                                                            name={String(question.id)}
                                                            defaultValue={ip}
                                                            ref={register}
                                                            hidden
                                                        />
                                                    )
                                                default:
                                                    break;
                                            }
                                        })
                                    }
                                </div>
                                <ButtonContainer>
                                    <Button type="button" className="secondary-button" isActive={false} onClick={handleDecline}>
                                        Declinar
                                    </Button>
                                    <Button type="submit" isActive={isActiveLoader}>
                                        Aceitar
                                    </Button>
                                </ButtonContainer>
                            </Form>
                        </>
                    )
                }
            </Container>
            <Fallback isActive={isActiveLoader} />
            <Footer />
        </>
    )
}